import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { IndexPage, ScenePage, ScoringPage } from 'pages'
import React from 'react'

export default function App () {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<IndexPage />} />
        <Route path="/score" element={<ScoringPage />} />
        <Route path="*" element={<ScenePage />} />
      </Routes>
    </Router>
  )
}
